export default "__VITE_ASSET__4Q77CFSW__"